import CreateAttributeList, { componentAttributeTypes, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";

export default class MyAccount extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.myaccount;
        this.displayName = "My Account";
        this.dropList = defaultDropList;
        this.editList = [...CreateAttributeList(true, true, true, true, false)];
        this.primaryEditAttributes = [attributeTypes.fontSize, attributeTypes.fontColor, attributeTypes.textAlign];
        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeDasharray="28" strokeDashoffset="28" strokeLinecap="round" strokeWidth="2"><path d="M4 21V20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20V21"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.4s" values="28;0"/></path><path d="M12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11Z"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.4s" values="28;0"/></path></g></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("v-review-percentage", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="myaccount" layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="myaccount" node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }
}
